import { HiOutlineTrash } from 'react-icons/hi';
import { ReportingControllerBaseConfig } from '../../base';
import { ButtonBlockController } from './buttonBlockInterface';
import { ButtonBlockViewProps } from './buttonBlockProps';
import { createBlockItemController } from '../block';

export function createButtonBlockController(
    config: ReportingControllerBaseConfig
): ButtonBlockController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;
    const formController = createFormController();
    const blockController = createBlockItemController();
    return {
        useProps(context, item, props): ButtonBlockViewProps {
            const form = formController.useProps(props.form);
            const block = blockController.useProps(context, item, props.item);
            return {
                label: item.button.text,
                button: {
                    ...form.getSubmitButtonProps(),
                },
                tooltip: {
                    ...form.getSubmitTooltipProps(),
                },
                form,
                block,
            };
        },
    };
}
